/* eslint-disable max-len */
const translation = {
  general: {
    errors: {
      required: 'Bitte füllen Sie alle erforderlichen Felder aus',
      emailError: 'Bitte geben Sie eine gültige E-Mail Adresse ein',
      generalError: 'Ein Fehler ist aufgetretten. Bitte versuchen Sie es erneut',
      error404: 'Nicht gefunden',
    },
  },
  notFound: {
    title: 'Ups! Die Seite, die Sie suchen, existiert nicht.',
    subtitle: 'Sie wurde vielleicht entfernt, umbenannt oder hat nie existiert.',
  },
  checkout: {
    checkoutErrors: {
      headline: 'Fehler',
    },
    steps: {
      chooseTicket: 'Tickets auswählen',
      chooseTicketSingular: 'Ticket auswählen',
      enterAttendee: 'Teilnehmerdaten eingeben',
      invoiceAddress: 'Rechnungsadresse eingeben',
      summary: 'Zusammenfassung',
      review: 'Zusammenfassung',
      payment: 'Zahlung',
    },
    invoiceAddress: {
      addressTypeTitle: 'Art der Adresse',
      addressTypeCompany: 'Unternehmen/Firma',
      addressTypePrivate: 'Privat',
      company: 'Firma',
      forename: 'Vorname',
      name: 'Name',
      address: 'Straße + Hausnummer',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      country: 'Land',
      emailAddress: 'E-Mail',
      extraFields: {
        title: 'Zusätzliche Rechnungsangaben',
        summary: 'Leitweg-ID, Projektnummer, Kostenstelle (optional)',
        leitwegId: {
          label: 'Leitweg-ID',
          helperText: 'Pflichtangabe für Rechnungen an öffentliche Auftraggeber',
        },
        projectNumber: {
          label: 'Projektnummer',
        },
        costCenter: {
          label: 'Kostenstelle',
        },
      },
    },
    back: 'Zurück',
    next: 'Weiter',
    soldOut: 'Ausverkauft',
    uploadErrors: {
      headline: 'Datei-Upload fehlgeschlagen',
      general: 'Die Datei konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.',
    },
    vatGrossLabel: 'inkl. MwSt.',
    vatNetLabel: 'zzgl. MwSt.',
    vatNotice: 'Alle Preise zzgl. MwSt.',
    vatNoticeShort: 'zzgl. MwSt.',
    submit: 'Kostenpflichtig bestellen',
    acceptTOS: `Ich bestätige, dass die Angaben, insbesondere Name und E-Mail-Adresse, von allfällig zusätzlichen Teilnehmenden korrekt sind.
        Dies ist wichtig, da die Tickets per E-Mail versendet werden. Des Weiteren akzeptiere ich die Teilnahmebedingungen der Seminar GmbH`,
    insufficientInventory: `Leider sind folgende Tickets nicht mehr oder nur in begrenzter Stückzahl verfügbar.
      Bitte passen Sie die Bestellmenge entsprechend an.`,
    insufficientInventoryAffectdCategories: 'Betroffene Kategorien',
    error: 'Fehler',
    paymentErrors: {
      headline: 'Zahlungsfehler',
      general: 'Bei der Zahlung ist ein Fehler aufgetreten. Bitte wählen Sie eine andere Zahlungsart.',
      insufficient_funds: 'Die Karte verfügt über unzureichende Deckung. Bitte verwenden Sie eine andere Kreditkarte.',
      lost_card: 'Diese Karte wurde als verloren gemeldet und ist gesperrt. Bitte verwenden Sie eine andere Kreditkarte.',
      stolen_card: 'Diese Karte wurde als gestohlen gemeldet und ist gesperrt. Bitte verwenden Sie eine andere Kreditkarte.',
      expired_card: 'Diese Karte ist abgelaufen. Bitte verwenden Sie eine andere Kreditkarte.',
      incorrect_cvc: 'Falscher Sicherheitscode (CVC). Bitte überprüfen Sie die Eingabe.',
      card_declined: 'Diese Kreditkarte wurde abgelehnt. Bitte verwenden Sie eine andere Kreditkarte.',
    },
    coupon: {
      label: 'Rabattcode',
      placeholder: 'Code eingeben',
      apply: 'Anwenden',
      remove: 'Entfernen',
      applied: 'Rabatt',
      error: 'Rabattcode konnte nicht angewendet werden',
      errors: {
        ENOTFOUND: 'Der eingegebene Rabattcode wurde nicht gefunden.',
        ENOTVALIDANYMORE: 'Dieser Rabattcode ist nicht mehr gültig.',
        ELIMITREACHED: 'Dieser Rabattcode wurde bereits vollständig eingelöst.',
        EALREADYADDED: 'Dieser Rabattcode wurde bereits angewendet.',
        ENOTAPPLICABLE: 'Dieser Rabattcode kann auf die aktuelle Auswahl nicht angewendet werden.',
      },
    },
  },
  texts: {
    imprint: 'Impressum',
    privacyPolicy: 'Datenschutz',
    toc: 'AGB',
    rightOfWithdrawal: 'Widerrufsrecht',
  },
  kiosk: {
    headline: 'Jetzt Ticket kaufen',
    buyHere: 'Hier auswählen & bezahlen',
    scanLabel: 'Scannen',
    modalTitle: 'Mit dem Smartphone bezahlen',
    modalInstruction: 'QR-Code mit der Kamera scannen und bequem mit dem eigenen Smartphone bezahlen.',
    endSession: 'Nächster Gast',
    endSessionConfirmTitle: 'Für nächsten Gast zurücksetzen?',
    endSessionConfirmDescription: 'Der aktuelle Kaufvorgang wird abgebrochen und das iPad zeigt wieder die Startseite.',
    endSessionConfirmButton: 'Zurücksetzen',
    endSessionCancelButton: 'Abbrechen',
    idleWarningTitle: 'Noch da?',
    idleWarningDescription: 'Der Kaufvorgang wird in {{seconds}} Sekunden für den nächsten Gast zurückgesetzt.',
    idleWarningContinue: 'Weiter kaufen',
    idleWarningReset: 'Jetzt zurücksetzen',
  },
};

export default translation;
